export default{
    settab (state, v){
        state.nav = v
    },

    setNavLeft (state, v){
        state.navleft = v
    },

    setTicket (state, v){
        state.ticket = v
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js